import { usePermissionStore } from './permissionStore'
import { useClientStore } from './clientStore'
import { useBuildingStore } from './buildingStore'
import { useLoadingStore } from './loadingStore'

/**
 * Single point of reset for all application stores.
 * Called reactively when token becomes null (logout / session expiry).
 */
export function resetAllStores() {
  usePermissionStore.getState().reset()
  useClientStore.getState().reset()
  useBuildingStore.getState().resetAll()
  useLoadingStore.getState().reset()
}
